// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) 2025 Robert Schiwon
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

/* navbar */

sf-navbar {
  height: 100%;
}

sf-navbar button {
  font-family: sans-serif;
  font-size: 1em;
  color: black;
}

/* logo */

sf-navbar > img.sf-logo {
  float: left;
  display: flex;
  align-items: center;
  height: calc(100% - 1em);
  padding: 0.5em 0.5em 0.5em 0.5em;
  outline-offset: -0.2em;
}

/* nav */

sf-navbar > nav {
  height: 100%;
  display: inline-block;
}

/* hamburger */

sf-navbar > button.sf-hamburger {
  background: none;
  color: inherit;
  border: none;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  display: none;
  position: relative;
  float: right;
  height: 100%;
  padding: 0em 0.5em 0em 0.5em;
  text-decoration: none;
  align-items: center;
  outline-offset: -0.2em;
}

sf-navbar > button.sf-hamburger:hover {
  background-color: #ddd;
}

/* mobile */

@media screen and (max-width: 576px) {
  /* nav */
  sf-navbar > nav {
    top: 100%;
    height: 0;
    position: relative;
    display: block;
  }
  /* hamburger */
  sf-navbar > button.sf-hamburger {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/menu/Navbar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF,WAAW;;AAEX;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;AACd;;AAEA,SAAS;;AAET;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,QAAQ;;AAER;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA,cAAc;;AAEd;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;;AAEX;EACE,QAAQ;EACR;IACE,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,cAAc;EAChB;EACA,cAAc;EACd;IACE,aAAa;EACf;AACF","sourcesContent":["/**\n * Copyright (c) 2025 Robert Schiwon\n *\n * Permission is hereby granted, free of charge, to any person obtaining a copy of\n * this software and associated documentation files (the \"Software\"), to deal in\n * the Software without restriction, including without limitation the rights to\n * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n * the Software, and to permit persons to whom the Software is furnished to do so,\n * subject to the following conditions:\n *\n * The above copyright notice and this permission notice shall be included in all\n * copies or substantial portions of the Software.\n *\n * THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n */\n\n/* navbar */\n\nsf-navbar {\n  height: 100%;\n}\n\nsf-navbar button {\n  font-family: sans-serif;\n  font-size: 1em;\n  color: black;\n}\n\n/* logo */\n\nsf-navbar > img.sf-logo {\n  float: left;\n  display: flex;\n  align-items: center;\n  height: calc(100% - 1em);\n  padding: 0.5em 0.5em 0.5em 0.5em;\n  outline-offset: -0.2em;\n}\n\n/* nav */\n\nsf-navbar > nav {\n  height: 100%;\n  display: inline-block;\n}\n\n/* hamburger */\n\nsf-navbar > button.sf-hamburger {\n  background: none;\n  color: inherit;\n  border: none;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  display: none;\n  position: relative;\n  float: right;\n  height: 100%;\n  padding: 0em 0.5em 0em 0.5em;\n  text-decoration: none;\n  align-items: center;\n  outline-offset: -0.2em;\n}\n\nsf-navbar > button.sf-hamburger:hover {\n  background-color: #ddd;\n}\n\n/* mobile */\n\n@media screen and (max-width: 576px) {\n  /* nav */\n  sf-navbar > nav {\n    top: 100%;\n    height: 0;\n    position: relative;\n    display: block;\n  }\n  /* hamburger */\n  sf-navbar > button.sf-hamburger {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
